(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ffn-lifebar-tasting"] && !Shopify.designMode) return;
  try {
    
(() => {
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const catalogue = JSON.parse(root.querySelector('[data-lifebar-catalogue]').textContent).map(product=>({...product,sku:product.variantId||product.sku}));
    const selected = new Map();
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const total = () => [...selected.values()].reduce((a,b) => a+b, 0);
    const escape = text => String(text).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
    const announce = message => { $('[data-status]').textContent = message; };
    const image = (product, extra='') => `<img src="${escape(product.image)}" alt="${escape(product.name)} Lifebar" width="600" height="400" ${extra}>`;
    const cards = new Map();
    const checkoutURL = root.dataset.checkoutUrl;
    const publicCampaign = root.dataset.publicCampaign === 'true';
    window.addEventListener('pageshow',()=>{const button=$('[data-start-checkout]');button.disabled=false;button.textContent='Continue to Shopify checkout ↗';});
    if (checkoutURL) {
      const guestCheckout=checkoutURL.includes('/lifebar-tasting');
      if(!publicCampaign)$('.lb-review-bar span').textContent = guestCheckout?'Unpublished preview · guest checkout test':'Unpublished preview · private checkout test';
      $('.lb-preview-label').textContent = publicCampaign?'Secure Shopify checkout · no account needed':guestCheckout?'Guest checkout · no account needed':'Private test · real Shopify checkout';
      $('.lb-dialog-intro').textContent = 'Check your flavours before continuing to Shopify.';
      $('.lb-dialog-notice').textContent = guestCheckout?'Continue with your delivery details, then pay £3.49 including UK delivery in Shopify. One tasting box per delivery address. Opening checkout takes no payment; paying places a real order.':'Private checkout test for Sam. Sign in to the FFN dashboard if prompted. Opening checkout takes no payment; paying places a real order.';
      $('[data-start-checkout]').hidden = false;
      $('[data-preview-faq]').textContent = 'This unpublished preview connects to a real Shopify checkout for testing. The tasting selection is £3.49 including UK delivery. Opening checkout takes no payment. Completing payment places a real order. One tasting box per delivery address for this campaign; separate flats are treated separately.';
      if(publicCampaign)$('[data-preview-faq]').textContent='Choose your flavours, enter your UK delivery details, then pay £3.49 securely in Shopify. UK delivery is included. One box per delivery address for this campaign; separate flats count separately. No subscription.';
    }
    const ranges = [...new Set(catalogue.map(product=>product.range))];
    $('.lb-filters').innerHTML = ['All',...ranges].map((range,index)=>`<button type="button" data-filter="${escape(range)}" aria-pressed="${index===0}">${range==='All'?'All flavours <span>'+catalogue.length+'</span>':escape(range)}</button>`).join('');
    if(!catalogue.length){ $('[data-products]').innerHTML='<p class="lb-empty-products">No bars are currently available in this selection.</p>'; }
    catalogue.forEach(product => {
      const card = document.createElement('article');
      card.className = 'lb-card';
      card.dataset.range = product.range;
      card.dataset.sku = product.sku;
      card.style.setProperty('--tint', product.tint);
      card.innerHTML = `<div class="lb-card-art">${image(product,'loading="lazy"')}<span class="lb-card-quantity" hidden></span></div><div class="lb-card-body"><p class="lb-card-range"><span>${escape(product.range)}</span><span>40g</span></p><h3>${escape(product.name)}</h3><a class="lb-card-details" href="${escape(product.url)}" target="_blank" rel="noopener" aria-label="Product details, ingredients and allergens for ${escape(product.name)} (opens a new tab)">Product details ↗</a><div class="lb-card-bottom"><span class="lb-card-price">Part of your box</span><div data-card-action></div></div></div>`;
      $('[data-products]').append(card);
      cards.set(product.sku, card);
    });
    function change(sku, amount) {
      const product = catalogue.find(item => item.sku === sku);
      if (!product || (amount > 0 && (!product.available || total() >= 3 || selected.has(sku)))) return;
      const quantity = Math.min(1, Math.max(0, (selected.get(sku) || 0) + amount));
      if (quantity) selected.set(sku, quantity); else selected.delete(sku);
      render();
      announce(`${product.name} ${amount > 0 ? 'added' : 'removed'}. ${total()} of 3 bars selected.${total() === 3 ? ' Your tasting box is full.' : ''}`);
    }
    function render() {
      const count = total();
      const active = catalogue.filter(product => selected.has(product.sku));
      cards.forEach((card, sku) => {
        const product = catalogue.find(item => item.sku === sku);
        const quantity = selected.get(sku) || 0;
        const badge = card.querySelector('.lb-card-quantity');
        badge.hidden = quantity === 0;
        badge.textContent = quantity;
        const action = card.querySelector('[data-card-action]');
        action.innerHTML = quantity ? `<button class="lb-add lb-picked" type="button" data-remove="${sku}" aria-label="Remove ${escape(product.name)} bar" title="Remove this bar">Selected ✓</button>` : `<button class="lb-add" type="button" data-add="${sku}" ${count >= 3 || !product.available ? 'disabled' : ''} aria-label="Add ${escape(product.name)} bar">${!product.available ? 'Unavailable' : count >= 3 ? 'Box full' : 'Add +'}</button>`;
      });
      $('[data-count-badge]').textContent = `${count} / 3`;
      $('[data-count-label]').textContent = `(${count})`;
      $('[data-selection-hint]').textContent = count === 0 ? 'Good things come in threes. Pick your first bar.' : count === 3 ? 'A full box of good choices. Ready to review?' : `Looking good. Add ${3-count} more, or review your selection.`;
      const slots = active.flatMap(product => Array.from({length:selected.get(product.sku)}, () => product));
      $('[data-slots]').innerHTML = Array.from({length:3}, (_,i) => slots[i] ? `<div class="lb-slot filled">${image(slots[i])}</div>` : `<div class="lb-slot" aria-label="Empty slot ${i+1}">+</div>`).join('');
      $('[data-selection-list]').innerHTML = active.map(product => `<div class="lb-selected-row"><span>${selected.get(product.sku)} × ${escape(product.name)}</span><button type="button" data-clear="${product.sku}" aria-label="Remove all ${escape(product.name)} bars">Remove</button></div>`).join('');
      const button = $('[data-review-order]');
      button.disabled = !count;
      button.innerHTML = count ? 'Review my selection <span>↗</span>' : 'Choose at least 1 bar <span>↗</span>';
      $('[data-mobile-count]').textContent = `${count} of 3 bars`;
      $('[data-mobile-review]').disabled = !count;
      $('[data-mobile-review]').textContent = count ? 'Review selection ↗' : 'Choose bars ↗';
    }
    function openOrder() {
      if (!total()) return;
      $('[data-dialog-items]').innerHTML = catalogue.filter(product => selected.has(product.sku)).map(product => `<div class="lb-dialog-item">${image(product)}<div><strong>${escape(product.name)}</strong><small>${escape(product.range)} · 40g · Qty ${selected.get(product.sku)}</small></div><span>Included</span></div>`).join('');
      $('[data-order-dialog]').showModal();
    }
    root.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || !root.contains(button)) return;
      if (button.dataset.add) change(button.dataset.add,1);
      if (button.dataset.remove) change(button.dataset.remove,-1);
      if (button.dataset.clear) { const product=catalogue.find(p=>p.sku===button.dataset.clear);selected.delete(button.dataset.clear);render();announce(`${product.name} removed. ${total()} of 3 bars selected.`); }
      if (button.hasAttribute('data-review-order') || button.hasAttribute('data-mobile-review')) openOrder();
      if (button.hasAttribute('data-start-checkout') && checkoutURL) {
        const ids = [...selected.keys()];
        if (!ids.length || ids.length > 3 || ids.some(id=>!/^\d+$/.test(id)||selected.get(id)!==1)) return;
        const url = new URL(checkoutURL);
        url.searchParams.set('variants',ids.join(','));
        button.disabled = true;
        button.textContent = 'Opening checkout…';
        location.assign(url.toString());
      }
      if (button.hasAttribute('data-open-notes')) $('[data-notes-dialog]').showModal();
      if (button.dataset.filter) {
        $$('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => {card.hidden = button.dataset.filter !== 'All' && card.dataset.range !== button.dataset.filter;});
        const count = [...cards.values()].filter(card=>!card.hidden).length;
        announce(`Showing ${count} ${button.dataset.filter === 'All' ? '' : button.dataset.filter+' '}flavours. Your selection is unchanged.`);
      }
    });
    root.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => {if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}}));
    render();
  }
  function init() { document.querySelectorAll('[data-lifebar-root]').forEach(mount); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
